(ns frontend.view.settings2.screening.events
  (:require
   [common.util :as cu :refer [equals? only-entity empty-string]]
   [frontend.actions.tenant :as tenant-actions]))

(defn save-tenant!
  [tenant-id attribute value on-success! on-error!]
  (tenant-actions/*->update! tenant-id
                             attribute
                             (if (and (string? value)
                                      (cu/blank-value? value))
                               nil
                               value)
                             on-success!
                             on-error!))
